module.exports = __webpack_public_path__ + "img/ปลาแฮดดัค.54a25a08.jpg";